var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.172 4.99992L5.58602 11.5859C5.395 11.7704 5.24264 11.9911 5.13782 12.2351C5.033 12.4791 4.97783 12.7416 4.97552 13.0071C4.97321 13.2727 5.02381 13.536 5.12438 13.7818C5.22494 14.0276 5.37344 14.2509 5.56123 14.4387C5.74902 14.6265 5.97232 14.775 6.21811 14.8756C6.4639 14.9761 6.72726 15.0267 6.99282 15.0244C7.25838 15.0221 7.52082 14.9669 7.76483 14.8621C8.00884 14.7573 8.22953 14.6049 8.41402 14.4139L14.828 7.82792C15.5567 7.07351 15.9598 6.0631 15.9507 5.01431C15.9416 3.96553 15.5209 2.96228 14.7793 2.22065C14.0377 1.47901 13.0344 1.05834 11.9856 1.04922C10.9368 1.04011 9.92643 1.44329 9.17202 2.17192L2.75702 8.75692C1.63171 9.88223 0.999512 11.4085 0.999512 12.9999C0.999512 14.5914 1.63171 16.1176 2.75702 17.2429C3.88233 18.3682 5.40859 19.0004 7.00002 19.0004C8.59145 19.0004 10.1177 18.3682 11.243 17.2429L17.5 10.9999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.5922fecf36e3d281a7ca5ac467bbc419.svg";
export { ForwardRef as ReactComponent };